import { t } from '../i18n/index.js';

/** Copyright and the privacy notice on every page. */
export function Footer() {
  return (
    <footer class="site-footer">
      <span>{t.footer.copyright}</span>
      <span aria-hidden="true">·</span>
      <a href="tietosuoja.html">{t.footer.privacy}</a>
    </footer>
  );
}
